// extracted by mini-css-extract-plugin
export var card = "_li-0";
export var content = "_li-2";
export var details = "_li-3";
export var icon = "_li-1";
export var iconBlue = "_li-5";
export var iconBrand = "_li-4";
export var iconGrayBlue = "_li-6";
export var iconGreen = "_li-7";
export var iconIndigo = "_li-8";
export var iconOrange = "_li-9";
export var iconPurple = "_li-a";
export var iconRed = "_li-b";
export var iconWarning = "_li-c";